<template>

    <SubHeader :title="'Informations sur le chat ' + (chatShowItems.phone ?? '')" :breads="[{ name: 'chat' }]"
        :action="{ to: 'CanauxWhatsapp', title: 'Revernir sur la liste' }" />
    <Modal>

        <div class="text-center" v-if="!isLoading">
            <span>Voulez-vous vraiment <b class="text-danger">Transformer ce chat en plainte ?</b>
            </span>

        </div>
        <div class="spinner-grow" role="status" v-else>
            <span class="visually-hidden">Loading...</span>
        </div>
        <template #btn>

            <button type="button" :disabled="createIsLoading || updateIsLoading" class="btn btn-primary"
                @click="submitModal">
                <span v-if="createIsLoading || updateIsLoading" class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                </span>
                <span v-else>
                    Convertir
                </span>
            </button>


        </template>
    </Modal>

    <div v-if="chatShowIsLoading" class="loading-overlay">
        <span class="loading-spinner">Chargement...</span>
        <div class="spinner"></div>
    </div>

    <div v-else class="row">
        <div class="col-lg-12">
            <div class="">
                <div class="card-body">

                    <!-- Nav -->
                    <div class="js-nav-scroller mb-5" style="width:fit-content">
                        <span class="hs-nav-scroller-arrow-prev" style="display: none;">
                            <a class="hs-nav-scroller-arrow-link" href="javascript:;">
                                <i class="bi-chevron-left"></i>
                            </a>
                        </span>

                        <span class="hs-nav-scroller-arrow-next" style="display: none;">
                            <a class="hs-nav-scroller-arrow-link" href="javascript:;">
                                <i class="bi-chevron-right"></i>
                            </a>
                        </span>
                        <ul class="nav nav-tabs align-items-center nav-justified" id="notificationTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" href="#notificationNavOne" id="notificationNavOne-tab"
                                    data-bs-toggle="tab" data-bs-target="#notificationNavOne" role="tab"
                                    aria-controls="notificationNavOne" aria-selected="true">Details</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#notificationNavTwo" id="notificationNavTwo-tab"
                                    data-bs-toggle="tab" data-bs-target="#notificationNavTwo" role="tab"
                                    aria-controls="notificationNavTwo" aria-selected="false">Plaintes créées</a>
                            </li>


                        </ul>


                    </div>
                    <!-- End Nav -->

                    <div class="tab-content" id="notificationTabContent">
                        <div class="tab-pane fade show active" id="notificationNavOne" role="tabpanel"
                            aria-labelledby="notificationNavOne-tab">
                            <div class="row">


                                <div class="col-lg-12">
                                    <div class="d-grid gap-3 gap-lg-5">
                                        <div class="row">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-header-title">Conversation récente</h4>
                                                </div>
                                                <div class="card-body">

                                                    <div class="chat-container">
                                                        <div v-for="message in chatShowItems.messages" :key="message.id"
                                                            :class="['chat-message', message.sender_id === message.chat_id ? 'received' : 'sent']">
                                                            <div class="message-content">
                                                                <template v-if="message.type === 'chat'">
                                                                    <p>{{ cleanContent(message.content) }}</p>
                                                                </template>

                                                                <template
                                                                    v-else-if="['png', 'webp'].includes(message.type)">
                                                                    <img :src="fileServeur + message.content"
                                                                        alt="Image" class="message-image" />
                                                                </template>

                                                                <template v-else-if="message.type === 'pdf'">
                                                                    <a :href="fileServeur + message.content"
                                                                        target="_blank" class="message-link">
                                                                        📄 Voir le PDF
                                                                    </a>
                                                                </template>

                                                                <template v-else-if="message.type === 'mp3'">
                                                                    <audio controls class="message-audio">
                                                                        <source :src="fileServeur + message.content"
                                                                            type="audio/mpeg">
                                                                        Votre navigateur ne prend pas en charge la
                                                                        lecture audio.
                                                                    </audio>
                                                                </template>

                                                                <template v-else-if="message.type === 'mp4'">
                                                                    <video controls class="message-video">
                                                                        <source :src="fileServeur + message.content"
                                                                            type="video/mp4">
                                                                        Votre navigateur ne prend pas en charge la
                                                                        lecture vidéo.
                                                                    </video>
                                                                </template>

                                                                <template v-else>
                                                                    <p>⚠️ Contenu non pris en charge</p>
                                                                </template>

                                                                <small>{{ message.sender_name }} - {{
                                                                    formatDate(message.date) }}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>


                                </div>
                            </div>
                            <div class="row mt-3" v-if="chatShowItems.messages && chatShowItems.messages.length > 0">
                                <div class="col-md-12">
                                    <div class="card">

                                        <div class="card-body text-center">
                                            <button @click="showModal(chatShowItems.id)"
                                                class="btn btn-primary">Convertir
                                                en
                                                Plainte</button>&nbsp;
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="tab-pane fade show" id="notificationNavTwo" role="tabpanel"
                            aria-labelledby="notificationNavTwo-tab">
                            <div class="row">
                                <div class="card">
                                    <div class="card-header">
                                        <h4 class="card-header-title">Plaintes créées</h4>
                                    </div>
                                    <div class="card-body">
                                        <data-table :rows="chatShowItems.complaint_count" :columns="cols"
                                            :loading="isLoading" :sortable="true" sortColumn="label" sortDirection="asc"
                                            paginationInfo="De {0} à {1} sur un total de {2}" :search="searchWord"
                                            noDataContent="Pas de resultat">

                                        </data-table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>



                    <!-- End Row -->
                </div>

            </div>
        </div>
    </div>


</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import Modal from "@/widgets/Modal";
// import notify from "@/utils/notify.js"
export default {
    name: "ShowChat",
    components: {
        SubHeader,
        Modal
    },
    data() {
        return {

            cols: [
                { field: 'phone', title: 'Numero du citoyen' },
                {

                    field: 'complaint.reference',
                    title: 'Plainte créée',
                    cellRenderer({ complaint }) {
                        const reference = complaint?.reference ?? " - ";
                        const complaintId = complaint?.id;

                        return `
                        <span 
                            class="badge bg-soft-info text-info" 
                            style="cursor: pointer;"
                            onclick="window.location.href = '/dossier/${complaintId}/show'"
                        >
                            ${reference} - Cliquez pour voir
                        </span>
                    `;
                    }
                },

                { field: 'created_at', title: 'Date de création', type: 'Date' },
            ],

            searchWord: null,
            userStateIsDisabled: false,
            fileServeur: process.env.VUE_APP_FILE_SERVER_ULR ?? "",
            chat: {
                id: null
            }
        }
    },
    computed: {
        ...mapFields("chat/show", {
            chatShowItems: "item",
            chatShowIsLoading: "isLoading",
            chatShowIsSuccess: "isSuccess",
        }),

        ...mapFields("chat/update", {
            updateIsLoading: "isLoading",
            updateIsUpdated: "isUpdated",
            updateIsSuccess: "isSuccess",
            updateShowMessage: "showMessage",
            updateMessage: "message",
            updateItems: "update"
        }),
        ...mapFields("widget/modal", {
            toggleModal: "showMessage",
        }),
    },

    watch: {
        updateIsUpdated(val) {
            if (val) {
                this.toggleModal = false;
                this.toggleStateElementId = null;
                this.chat = {
                    id: null
                }
                this.getChat(this.$route.params.id ?? 0)
            }
        }
    },
    methods: {

        formatDate(date) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
            return new Date(date).toLocaleDateString('fr-FR', options);
        },
        cleanContent(content) {
            const unquotedContent = content.replace(/^"(.*)"$/, '$1');
            try {
                return JSON.parse(`"${unquotedContent}"`);
            } catch (error) {
                console.error("Erreur lors du décodage des séquences Unicode :", error);
                return unquotedContent;
            }
        },
        ...mapActions({
            getChat: "chat/show/getOne",
            updateChat: "chat/update/update",
        }),
        showModal() {
            this.toggleModal = true
        },
        submitModal() {
            this.chat.id = this.chatShowItems.id
            this.updateChat(this.chat)
        },


    },

    mounted() {
        this.getChat(this.$route.params.id ?? 0)
    },
    unmounted() {
    }
}
</script>

<style scoped>
.chat-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
}

.chat-message {
    max-width: 70%;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 10px;
}

.chat-message.sent {
    align-self: flex-end;
    background-color: #d1e7dd;
}

.chat-message.received {
    align-self: flex-start;
    background-color: #fbf6f6;
}

.message-content p {
    margin: 0;
}

.message-content small {
    display: block;
    margin-top: 5px;
    font-size: 12px;
    color: #6c757d;
}

.message-image {
    max-width: 100%;
    max-height: 300px;
    object-fit: contain;
    border-radius: 8px;
}

.message-video {
    width: 100%;
    max-width: 400px;
    max-height: 300px;
    border-radius: 8px;
}

.message-audio {
    width: 100%;
    max-width: 400px;
}

.message-link {
    color: #0d6efd;
    text-decoration: none;
    word-wrap: break-word;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.loading-spinner {
    color: white;
    font-size: 24px;
}

.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid white;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.chat-container {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 10px;
}
</style>
